export default __webpack_public_path__ + "static/shopping-centre-3-7aa18fe155808f2ac6bf00063e4e5025.jpg";